import styled from 'styled-components';
import { TextLabel } from '../TextLabel';

const StyledContainer = styled.div`
	transition: opacity 0.3s ease;

	&.tab-enter {
		opacity: 0;
	}

	&.tab-enter-active,
	&.tab-enter-done,
	&.tab-exit {
		opacity: 1;
	}

	&.tab-exit-active {
		opacity: 0;
	}
`;

const StyledHeadContainer = styled.div`
	position: relative;
	display: grid;
	grid-template-columns: 100px 1fr 100px;
	align-items: center;
	justify-content: space-between;
	gap: 20px;
	height: 80px;
	padding: 0 24px;
	border-bottom: 1px solid rgba(255, 255, 255, 0.1);

	& > *:last-child {
		justify-self: flex-end;
	}
`;

const StyledSearchInput = styled.input`
	width: 100%;
	background-color: transparent;
	font-family: 'GT Walsheim Pro';
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	line-height: 16px;
	text-align: center;
	color: #ffffff;
	transition: color 0.3s ease;
	outline: none;
	border: none;

	&::placeholder {
		color: rgba(255, 255, 255, 0.25);
		transition: color 0.3s ease;
		user-select: none;
	}

	&:hover {
		&::placeholder {
			color: rgba(255, 255, 255, 0.5);
		}
	}
`;

const StyledFriendsContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 27px;
	height: 548px;
	padding: 27px 24px 30px;
	overflow-y: scroll;

	&::-webkit-scrollbar {
		display: none;
	}
`;

const StyledFriendsByStatusContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 17px;
`;

const StyledStatusContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	.dot {
		width: 6px;
		height: 6px;
		border-radius: 6px;
	}

	${TextLabel} {
		font-weight: 500;
		font-size: 14px;
		color: #77de38;
	}
`;

const StyledOnlineStatusContainer = styled(StyledStatusContainer)`
	.dot {
		background-color: #77de38;
	}

	${TextLabel} {
		color: #77de38;
	}
`;

const StyledOfflineStatusContainer = styled(StyledStatusContainer)`
	.dot {
		background-color: rgba(255, 255, 255, 0.25);
	}

	${TextLabel} {
		color: rgba(255, 255, 255, 0.25);
	}
`;

const StyledFriendsList = styled.div`
	display: flex;
	gap: 10px;
	flex-wrap: wrap;
`;

const StyledNotFoundContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 548px;

	${TextLabel} {
		font-size: 16px;
		text-align: center;
		color: #ffffff;
		opacity: 0.25;
	}
`;

export {
	StyledContainer,
	StyledHeadContainer,
	StyledSearchInput,
	StyledFriendsContainer,
	StyledOnlineStatusContainer,
	StyledOfflineStatusContainer,
	StyledFriendsByStatusContainer,
	StyledFriendsList,
	StyledNotFoundContainer,
};
